import { Box, Card, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { NotificationServices } from './NotificationServices';
import Loading from '../../../components/Loader/Loading';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/pagination/CustomPagination';
import { formatDateTime } from '../../../utils/dateUtils';

const NotificationList = () => {
  // State to store the total row count inititally before server respond
  const [rowCount, setRowCount] = useState(5);

  // State to store the row count used by the DataGrid
  const [rowCountState, setRowCountState] = useState(rowCount);

  // Update rowCountState whenever rowCount changes
  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      rowCount !== undefined ? rowCount : prevRowCountState,
    );
  }, [rowCount, setRowCountState]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
    filters: {
      searchKey: "",
      sortKey: 'scheduleTime',
      sortDirection: 'desc',
      filterOptions: []
    }
  });

  const handlePaginationModel = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }
  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortKey,
      sort: paginationModel.filters.sortDirection,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortKey: newSortModel[0].field,
          sortDirection: newSortModel[0].sort
        }
      }));
    }
  }
  const columns = [
    // { field: 'id', headerName: 'S.NO.', flex: 1 ,sortable:'false'},
    {
      field: 'title', headerName: 'title', flex: 1.5, headerAlign: 'center',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'left' }}>
          <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
        </Box>
      ),
     },
    {
      field: 'body', headerName: 'Message', flex: 2, headerAlign: 'center',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'left' }}>
          <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
        </Box>
      ),
     },
    {
      field: 'scheduleTime',headerName: 'Sent On',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{fontSize:'0.6rem',color:'#000000de'}}>{params.row.scheduleTime && formatDateTime(params.row.scheduleTime)}</Typography>
      ),
    },
  ]
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const fetchNotificationList = async () => {
    setIsloading(true);
    try {
      const notificationResponse = await NotificationServices.fetchNotification({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortKey: paginationModel.filters.sortKey,
          sortDirection: paginationModel.filters.sortDirection,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      if (notificationResponse.success == '1') {
        setNotifications(notificationResponse.data.notifications);
        setRowCount(notificationResponse.data.pagination.totalCount);
      } else if (notificationResponse.success == '0') {
        console.log("Error fetching Notifications:", notificationResponse.message);
      }
    } catch (error) {
      console.log("Error fetching Notifications:", error)
    } finally { setIsloading(false); }
  }
  useEffect(() => {
    fetchNotificationList();
  }, [paginationModel])
  return (
    <Box>
      <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
        <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >Sent Notifications</Typography>
      </Box>
      <Card>
        <Box sx={{ overflow: "auto" }}>
          <Box
            sx={{
              width: "100%", display: "table", tableLayout: "fixed",
              backgroundColor: "#fff", borderRadius: '.5rem',
              '& .odd': {
                bgcolor: 'white',
              },
              '& .even': {
                bgcolor: '#ECECEC',
              },
            }}>

            {isLoading && <Loading />}
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {/* <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                  defaultFilterOptions={paginationModel.filters.filterOptions}
                /> */}
                {/* <ExportAll paginationModel={paginationModel} columns={columns} statusOptions={statusOptions} /> */}
              </Box>
              {/* <Box>
                <TextField
                  value={quickFilterText}
                  onChange={(event) => setQuickFilterText(event.target.value)}
                  placeholder="Quick Search ..."
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: '0px',
                    }
                  }}
                  InputProps={{
                    inputProps: {
                      style: {
                        height: '0.6rem',
                        textTransform: 'uppercase',
                        fontSize: 'x-small'
                      },
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <Search sx={{ fontSize: 'x-small' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box> */}
            </Box>
            <DataGrid
              rows={notifications}
              columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
              }))}
              getRowId={(row) => row._id}
              rowCount={rowCount}
              pageSizeOptions={[5, 10, 20, 50, 100]}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={handlePaginationModel}

              // Add these props for page numbers
              showFirstButton={true}
              showLastButton={true}

              // filterModel={filterModel}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={handleSortingChange}
              disableMultiSort={true}

              loading={isLoading}
              getRowClassName={(params) => {
                // console.log("checking customer is deleted",params.row.customer?.deletedAt)
                // Check if customer is deleted
                if (params.row.customer?.deletedAt) {
                  return 'deleted-row';
                }
                // Keep alternating row colors for non-deleted rows
                return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }}

              disableColumnMenu
              disableRowSelectionOnClick
              // disableColumnFilter
              // disableColumnSelector
              disableDensitySelector
              sortingOrder={['asc', 'desc']}
              slots={{
                // toolbar: GridToolbar,
                loadingOverlay: Loading,
                // Optionally use custom pagination
                // pagination: CustomPagination,
              }}
              // slotProps={{
              //   toolbar: {
              //     showQuickFilter: true,  
              //   },
              // }}
              autoHeight
              getRowHeight={() => 'auto'}
              sx={{
                minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                "& .MuiDataGrid-root": {
                  overflowX: "auto",
                },
                // Hide default footer since we're using custom pagination
                '& .MuiDataGrid-footerContainer': {
                  display: 'block'
                },
                '& .MuiDataGrid-row': {
                  '& .MuiDataGrid-cell': {
                    py: 1
                  },
                  // Add styles for deleted rows
                  '&.deleted-row': {
                    backgroundColor: '#ffebee !important', // Light red background
                    '&:hover': {
                      backgroundColor: '#ffcdd2 !important', // Darker red on hover
                    }
                  }
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p: 0,
                  height: 'fit-content',
                  minHeight: '0 !important',
                  height: '2rem'
                },
                // '& .MuiDataGrid-columnHeader': {
                //   borderLeft: '1px solid rgba(224, 224, 224, 1)',
                //   '&:last-child': {
                //     borderRight: 'none',
                //   },
                // },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 600,
                  color: '#3e3e3e'
                },

              }}
            />
          </Box>
        </Box>
      </Card>
    </Box>
  )
}

export default NotificationList